// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"d0527588","162":"bb6fb04d","543":"7994fc00","585":"30e3db83","605":"e927fe9d","611":"e88be7ca","696":"38af20a8","783":"60b4d8d6","936":"7ab86124"}[chunkId] + ".css";
};